export const backgroundColor = "transparent";
export const black = "#212121"; //change global color at theme.css too
export const blackNo2 = "#424242";
export const gray = "#ddd";
export const accent = "#64FFDA";
export const primary = "#2e2f2e";
